

export const TO_BUY_SUCCESS = 'TO_BUY_SUCCESS';
export const TO_BUY_UPDATE  = 'TO_BUY_UPDATE';
export const TO_BUY_ORDER   = 'TO_BUY_ORDER';
export const TO_BUY_REMOVE  = 'TO_BUY_REMOVE';